<template>
  <CardBase class="mb-4">
    <template #header>
      {{ row.name }}
      <router-link
        v-if="userCan('update.bank-account')"
        :to="{ name: 'BankAccountEdit', params: { id: $route.params.bankId } }"
        class="text-sm ml-1 text-gray-600 text-opacity-50 hover:text-blue-600 hover:text-opacity-100"
        v-tooltip="'Edit Bank'"
      >
        <font-awesome-icon :icon="['fas', 'edit']" />
      </router-link>
    </template>
    <template #content>
      <!-- Balance: {{ row.balance }} -->
      <span v-if="balanceLoading">
        <font-awesome-icon :icon="['fas', 'spinner']" spin class="ml-2" />
      </span>
      <span v-else>Balance: {{ row.balance }}</span>
    </template>
  </CardBase>
</template>

<script>
export default {
  name: "BankCard",
  props: {
    row: {
      type: Object,
      required: true,
    },
    balanceLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>